var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-content",attrs:{"slot":"error-page"},slot:"error-page"},[_c('img',{staticClass:"error-img",attrs:{"src":require("../../assets/403.png"),"alt":""}}),_c('p',{staticClass:"p2"},[_vm._v("抱歉，您暂时没有权限访问该页面")])])}
var staticRenderFns = []

export { render, staticRenderFns }